/**
 * 权限组管理
 */
import { requestGet, requestPost } from '@/utils/request';
import { EPermissionGroupType, TPermissionGroup } from '@/models/PermissionGroup';

/**
 * 新建权限组
 * @param form
 */
export async function createOrUpdatePermissionGroup(form: TPermissionGroup) {
  return requestPost(`/v2/camp/api/permission/group`, form);
}

/**
 * 获取权限组列表
 * @param type
 */
export async function listPermissionGroup(type: EPermissionGroupType) {
  return requestGet(`/v2/camp/api/permission/group`, { type });
}

/**
 * 获取权限组详情
 * @param id
 */
export async function getPermissionGroup(id: string) {
  return requestGet(`/v2/camp/api/permission/group/${id}`, {});
}
